export { default } from './CustomMenuIcon';
